import React from 'react';
import Header from '../../../../Header';
import Footer from '../../../../Footer';
import BrokerageCalculator from './BrokerageCalculator';

const BrokerageInfo = () => {
  return (
    <div className="bg-[#FFFFFF] rounded-lg shadow-lg p-6">
      <h2 className="text-[#1C52A0] text-2xl font-semibold mb-4">Brokerage Calculator</h2>
      <p className="mb-4 text-[#0D0D0D]">The Brokerage Calculator helps traders and investors calculate the total brokerage charges and transaction costs for stock market trades. It provides a clear breakdown of all fees, helping you make informed trading decisions and manage your trading costs effectively.</p>

      <h3 className="text-[#1C52A0] text-xl font-semibold mb-3">Key Components</h3>
      <ul className="list-disc pl-6 mb-4 text-[#0D0D0D]">
        <li>Trade Value</li>
        <li>Brokerage Rate</li>
        <li>Transaction Charges</li>
        <li>Stamp Duty</li>
        <li>GST</li>
      </ul>

      <h3 className="text-[#1C52A0] text-xl font-semibold mb-3">How It Works</h3>
      <p className="mb-4 text-[#0D0D0D]">The calculator considers various factors to determine total trading costs:</p>
      <ul className="list-disc pl-6 mb-4 text-[#0D0D0D]">
        <li>Brokerage = Trade Value × Brokerage Rate</li>
        <li>Transaction Charges = Trade Value × 0.00325%</li>
        <li>Stamp Duty = Trade Value × 0.015%</li>
        <li>GST = (Brokerage + Transaction Charges) × 18%</li>
      </ul>

      <h3 className="text-[#1C52A0] text-xl font-semibold mb-3">Benefits</h3>
      <ul className="list-disc pl-6 mb-4 text-[#0D0D0D]">
        <li>Calculate exact trading costs</li>
        <li>Compare different brokerage plans</li>
        <li>Plan trades effectively</li>
        <li>Manage trading expenses</li>
        <li>Make informed trading decisions</li>
      </ul>

      <h3 className="text-[#1C52A0] text-xl font-semibold mb-3">Using the Calculator</h3>
      <p className="mb-4 text-[#0D0D0D]">Enter your trade value and brokerage rate to calculate the total trading costs. The calculator will provide a detailed breakdown of all charges, helping you understand the complete cost structure of your trades.</p>
    </div>
  );
};

const Brokerage = () => {
  return (
    <>
      <Header/>
      <main className="overflow-x-hidden">
        <div className="relative z-20">
          <BrokerageCalculator/>
        </div>
        <BrokerageInfo />
      </main>
      <div className="relative z-20">
        <Footer />
      </div>
    </>
  );
};

export default Brokerage;